import { ITableState } from '../../base';
enum storageKeys {
    tableState = 'tableState',
}

export const loadTableStateFromSession = ():
    | { [key: string]: ITableState }
    | undefined => {
    try {
        const serializedState = sessionStorage.getItem(storageKeys.tableState);
        if (serializedState === null) {
            return undefined;
        }
        return JSON.parse(serializedState) as { [key: string]: ITableState };
    } catch (err) {
        console.error('Failed to load table state from session storage', err);
        return undefined;
    }
};

export const saveTableStateToSession = (
    tableId: string,
    tableState: ITableState
) => {
    try {
        const serializedState = sessionStorage.getItem(storageKeys.tableState);
        const statesToPersist = serializedState
            ? JSON.parse(serializedState)
            : {};
        statesToPersist[tableId] = tableState;

        sessionStorage.setItem(
            storageKeys.tableState,
            JSON.stringify(statesToPersist)
        );
    } catch (err) {
        console.error('Failed to save state to session storage', err);
    }
};

export const updateTableDataByRow = (
    tableData: Array<Record<string, string | number | null>>,
    newRowData: Record<string, string | number | null>
): Array<Record<string, string | number | null>> => {
    const jobIndex = tableData.findIndex((row) => row.id === newRowData.id);
    if (jobIndex !== -1) {
        tableData[jobIndex] = newRowData;
    }
    return tableData;
};
